import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Placeholder from '../Placeholder';

import './styles/template_selector.scss';

class TemplateSelector extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired,

    getSnippets: PropTypes.func.isRequired
  };

  static defaultProps = {
    items: [],

    getSnippets: () => false
  };

  constructor(props) {
    super(props);

    this.state = {
      value: ''
    };
  }

  render() {
    const {items, onChange} = this.props;

    return <div className='template-selector'>
      <div className='control-group'>
        <label className='control-label'>Insert template</label>
        <div className='controls'>
          <Placeholder.select ready={!items.pending}>
            <Select
              className='control-Select'
              clearable={false}
              onChange={
                (selected) => {

                  let selectedSnippet = items.find((item) => item.id === selected.value);

                  onChange(selectedSnippet);
                  this.setState({value: selected ? selected.value : null})
                }
              }
              options={items.map(item => ({label: item.name, value: item.id}))}
              value={this.state.value}
            />
          </Placeholder.select>
        </div>
      </div>
    </div>;
  }

  componentDidMount() {
    const {getSnippets, items} = this.props;

    if (items.pending && !items.fetching) {
      getSnippets();
    }
  }
}

export default TemplateSelector;
